(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(function () {
    if (!window.location.pathname.startsWith('/collections/')) return;

    var description = document.querySelector('.collection__description');
    if (!description) return;

    var rte = description.querySelector('.rte');
    if (!rte) return;

    var style = document.createElement('style');
    style.textContent = [
      '@media (max-width: 749px) {',
      '  .pct-collection-mobile-copy { position: relative; }',
      '  .pct-collection-mobile-copy.is-collapsed { max-height: 6.9em; overflow: hidden; }',
      '  .pct-collection-mobile-copy.is-collapsed::after { content: ""; position: absolute; left: 0; right: 0; bottom: 0; height: 2.4em; background: linear-gradient(to bottom, rgba(255,255,255,0), #fff); pointer-events: none; }',
      '  .pct-collection-read-more { display: inline-block; margin-top: 8px; padding: 0; border: 0; background: none; text-decoration: underline; font: inherit; cursor: pointer; }',
      '}',
      '@media (min-width: 750px) { .pct-collection-read-more { display: none !important; } }'
    ].join('\n');
    document.head.appendChild(style);

    rte.classList.add('pct-collection-mobile-copy');

    function applyMobileState() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile) {
        rte.classList.remove('is-collapsed');
        var existingDesktopButton = description.querySelector('.pct-collection-read-more');
        if (existingDesktopButton) existingDesktopButton.hidden = true;
        return;
      }

      var button = description.querySelector('.pct-collection-read-more');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'pct-collection-read-more';
        button.textContent = 'Read more';
        rte.insertAdjacentElement('afterend', button);

        button.addEventListener('click', function () {
          var collapsed = rte.classList.toggle('is-collapsed');
          button.textContent = collapsed ? 'Read more' : 'Show less';
          button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
      }

      button.hidden = false;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Read more';

      rte.classList.remove('is-collapsed');
      var needsCollapse = rte.scrollHeight > 120;
      if (needsCollapse) {
        rte.classList.add('is-collapsed');
        button.hidden = false;
      } else {
        button.hidden = true;
      }
    }

    applyMobileState();
    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = 0;
        applyMobileState();
      });
    }, { passive: true });
  });
})();

(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(function () {
    function replaceTextNode(node) {
      if (!node || node.nodeType !== Node.TEXT_NODE) return;
      if (/^\s*chat\s*$/i.test(node.nodeValue || '')) {
        node.nodeValue = node.nodeValue.replace(/chat/i, 'Get Advice');
      }
    }

    function styleMobileChat(root) {
      if (!root || !root.querySelectorAll || !window.matchMedia('(max-width: 749px)').matches) return;

      root.querySelectorAll('button, [role="button"], a').forEach(function (el) {
        var text = (el.textContent || '').trim();
        var aria = (el.getAttribute && el.getAttribute('aria-label')) || '';
        if (!/^(chat|get advice)$/i.test(text) && !/^(chat|get advice)$/i.test(aria)) return;

        el.style.fontSize = '13px';
        el.style.minHeight = '40px';
        el.style.padding = '8px 12px';
      });
    }

    function scan(root) {
      if (!root) return;

      if (root.nodeType === Node.TEXT_NODE) {
        replaceTextNode(root);
        return;
      }

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        replaceTextNode(node);
      }

      if (!root.querySelectorAll) return;

      root.querySelectorAll('[aria-label]').forEach(function (el) {
        var ariaLabel = el.getAttribute('aria-label');
        if (ariaLabel && /^\s*chat\s*$/i.test(ariaLabel)) {
          el.setAttribute('aria-label', 'Get Advice');
        }
      });

      styleMobileChat(root);

      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          scan(el.shadowRoot);
          watchRoot(el.shadowRoot);
        }
      });
    }

    function watchRoot(root) {
      if (!root || root.__pctChatObserved) return;
      root.__pctChatObserved = true;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') {
            replaceTextNode(mutation.target);
            return;
          }

          mutation.addedNodes.forEach(function (node) {
            scan(node);
          });
        });
      });

      observer.observe(root, { childList: true, subtree: true, characterData: true });
    }

    function attachChatRoot() {
      var chat = document.querySelector('shopify-chat');
      if (!chat || !chat.shadowRoot) return false;
      scan(chat.shadowRoot);
      watchRoot(chat.shadowRoot);
      return true;
    }

    scan(document.body);
    watchRoot(document.body);

    if (!attachChatRoot()) {
      var chatObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
            var node = mutations[i].addedNodes[j];
            if (node.nodeType !== 1) continue;

            if ((node.matches && node.matches('shopify-chat')) || (node.querySelector && node.querySelector('shopify-chat'))) {
              if (attachChatRoot()) {
                chatObserver.disconnect();
                return;
              }
            }
          }
        }
      });

      chatObserver.observe(document.body, { childList: true, subtree: true });
    }
  });
})();

(function () {
  function makeGemBadgeClickable() {
    document.querySelectorAll('.pct-gem-under-price > .pct-payment-brand--gem').forEach(function (badge) {
      if (badge.dataset.pctGemLinkReady) return;
      badge.dataset.pctGemLinkReady = '1';
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-label', 'Learn about Gem Visa');
      badge.style.cursor = 'pointer';

      function goToGem() {
        window.location.href = '/pages/gem';
      }

      badge.addEventListener('click', goToGem);
      badge.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToGem();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeGemBadgeClickable, { once: true });
  } else {
    makeGemBadgeClickable();
  }
})();

(function () {
  var path = window.location.pathname;
  if (!(path.startsWith('/collections/') || path === '/')) return;

  function ensureStyle() {
    if (document.getElementById('pct-card-afterpay-style')) return;
    var style = document.createElement('style');
    style.id = 'pct-card-afterpay-style';
    style.textContent = '.pct-card-afterpay{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:7px!important;width:max-content!important;max-width:100%!important;margin:5px 0 2px!important;text-align:left!important}.pct-card-afterpay .pct-afterpay-logo-link{display:inline-flex!important;align-items:center!important;justify-content:flex-start!important;line-height:1!important;margin:0!important;padding:0!important;text-decoration:none!important;flex:none!important}.pct-card-afterpay .pct-afterpay-logo-link .pct-payment-brand--afterpay{display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:4px 7px!important;border:1px solid #d8d8d8!important;border-radius:3px!important;background:#b2fce4!important;color:#111!important;font-size:10px!important;font-weight:800!important;line-height:1!important;letter-spacing:-.2px!important;min-width:58px!important;box-sizing:border-box!important}.pct-card-afterpay__text{font-size:12px!important;line-height:1.35!important;color:#555!important;white-space:nowrap!important;margin:0!important;padding:0!important}@media(max-width:640px){.pct-card-afterpay{gap:6px!important;margin-top:5px!important}.pct-card-afterpay__text{font-size:11px!important}}';
    document.head.appendChild(style);
  }

  function processCard(card) {
    if (!card || !card.matches || !card.matches('.product-item')) return;

    var priceList = card.querySelector('.product-item__price-list');
    if (!priceList) return;

    var priceEl = priceList.querySelector('.price--highlight') || priceList.querySelector('.price:not(.price--compare)');
    if (!priceEl) return;

    var priceText = (priceEl.textContent || '').replace(/,/g, '');
    var match = priceText.match(/([0-9]+(?:\.[0-9]+)?)/);
    if (!match) return;

    var installment = parseFloat(match[1]) / 4;
    if (!isFinite(installment)) return;
    var amount = installment.toFixed(2);

    var line = card.querySelector('.pct-card-afterpay');
    if (!line) {
      line = document.createElement('div');
      line.className = 'pct-card-afterpay';
      line.innerHTML = '<a class="pct-afterpay-logo-link" href="/pages/afterpay" aria-label="Learn about Afterpay"><span class="pct-payment-brand pct-payment-brand--afterpay" aria-label="Afterpay">Afterpay</span></a><span class="pct-card-afterpay__text"></span>';
    }

    if (line.dataset.pctInstallment !== amount) {
      var text = line.querySelector('.pct-card-afterpay__text');
      if (text) text.textContent = 'or 4 payments of $' + amount;
      line.dataset.pctInstallment = amount;
    }

    if (priceList.nextElementSibling !== line) {
      priceList.insertAdjacentElement('afterend', line);
    }
  }

  function collectCards(node, cards) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches('.product-item')) {
      cards.add(node);
    } else if (node.closest) {
      var parentCard = node.closest('.product-item');
      if (parentCard) cards.add(parentCard);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll('.product-item').forEach(function (card) {
        cards.add(card);
      });
    }
  }

  function startCompactAfterpay() {
    ensureStyle();
    document.querySelectorAll('.product-item').forEach(processCard);

    var pendingCards = new Set();
    var frameId = 0;

    function flushCards() {
      frameId = 0;
      pendingCards.forEach(processCard);
      pendingCards.clear();
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          collectCards(node, pendingCards);
        });
      });

      if (pendingCards.size && !frameId) {
        frameId = window.requestAnimationFrame(flushCards);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCompactAfterpay, { once: true });
  } else {
    startCompactAfterpay();
  }
})();

(function () {
  function cleanLegacyConditionReferences() {
    if (!window.location.pathname.startsWith('/products/')) return;

    document.querySelectorAll('.product-block-list__item--description .rte').forEach(function (description) {
      description.querySelectorAll('a[href*="/pages/laptop-grading"]').forEach(function (link) {
        var previous = link.previousSibling;
        var removed = 0;
        while (previous && removed < 2) {
          var before = previous.previousSibling;
          if (previous.nodeType === 1 && previous.tagName === 'BR') {
            previous.remove();
            removed += 1;
            previous = before;
          } else if (previous.nodeType === 3 && /^\s*$/.test(previous.nodeValue || '')) {
            previous = before;
          } else {
            break;
          }
        }

        var next = link.nextSibling;
        removed = 0;
        while (next && removed < 2) {
          var after = next.nextSibling;
          if (next.nodeType === 1 && next.tagName === 'BR') {
            next.remove();
            removed += 1;
            next = after;
          } else if (next.nodeType === 3 && /^\s*$/.test(next.nodeValue || '')) {
            next = after;
          } else {
            break;
          }
        }

        link.remove();
      });

      var walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var originalText = node.nodeValue;
        if (!originalText || !/Refurbished Laptop Cosmetic Condition Guide|Quality Checked\s*&\s*Graded/i.test(originalText)) continue;
        var updatedText = originalText
          .replace(/Refurbished Laptop Cosmetic Condition Guide/gi, '')
          .replace(/Quality Checked\s*&\s*Graded/gi, 'Professionally Tested & Quality Checked');
        if (updatedText !== originalText) node.nodeValue = updatedText;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanLegacyConditionReferences, { once: true });
  } else {
    cleanLegacyConditionReferences();
  }
})();

(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(function () {
    if (document.getElementById('pct-price-nowrap-style')) return;

    var style = document.createElement('style');
    style.id = 'pct-price-nowrap-style';
    style.textContent = [
      '.pct-demo-price-area .price-list{display:flex!important;align-items:baseline!important;flex-wrap:nowrap!important;gap:0 10px!important;white-space:nowrap!important}',
      '.pct-demo-price-area .price-list .price{flex:0 0 auto!important;white-space:nowrap!important}',
      '.product-item__price-list{display:flex!important;align-items:baseline!important;flex-wrap:nowrap!important;gap:0 6px!important;white-space:nowrap!important}',
      '.product-item__price-list .price{flex:0 0 auto!important;white-space:nowrap!important}',
      '@media(max-width:767px){',
      '  .pct-demo-price-area .price-list{gap:0 7px!important}',
      '  .pct-demo-price-area .price-list .price:not(.price--compare){font-size:26px!important}',
      '  .pct-demo-price-area .price-list .price--compare{font-size:14px!important}',
      '  .product-item__price-list{gap:0 4px!important;font-size:12px!important}',
      '  .product-item__price-list .price--highlight{font-size:14px!important}',
      '  .product-item__price-list .price--compare{font-size:12px!important}',
      '}',
      '@media(max-width:374px){',
      '  .pct-demo-price-area .price-list .price:not(.price--compare){font-size:24px!important}',
      '  .pct-demo-price-area .price-list .price--compare{font-size:13px!important}',
      '  .product-item__price-list{gap:0 3px!important;font-size:11px!important}',
      '  .product-item__price-list .price--highlight{font-size:13px!important}',
      '  .product-item__price-list .price--compare{font-size:11px!important}',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  });
})();

/* PCT Universal Condition Fix 121026 */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  var CONDITION_KEYS = {
    condition: true,
    productcondition: true,
    cosmeticcondition: true,
    cosmeticcondtion: true,
    cosmetic: true
  };

  var KNOWN_GRADES = {
    'excellenta+': true,
    excellent: true,
    verygood: true,
    good: true
  };

  function normalise(text) {
    return (text || '').toLowerCase().trim().replace(/[\s_-]+/g, '');
  }

  function getOptionLabel(root) {
    return root.querySelector('.product-form__option-name');
  }

  function getOptionName(label) {
    if (!label) return '';

    for (var i = 0; i < label.childNodes.length; i += 1) {
      var node = label.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && (node.nodeValue || '').trim()) {
        return (node.nodeValue || '').replace(/:\s*$/, '').trim();
      }
    }

    return (label.textContent || '').split(':')[0].trim();
  }

  function getSelectedValue(root, label) {
    var selectedValue = root.querySelector('.product-form__selected-value');
    if (selectedValue && selectedValue.textContent.trim()) {
      return selectedValue.textContent.trim();
    }

    var checked = root.querySelector('input:checked');
    if (checked && checked.value) return checked.value.trim();

    var select = root.querySelector('select');
    if (select && select.options && select.selectedIndex >= 0) {
      return (select.options[select.selectedIndex].textContent || select.value || '').trim();
    }

    var text = (label && label.textContent) || '';
    var colonIndex = text.indexOf(':');
    return colonIndex >= 0 ? text.slice(colonIndex + 1).trim() : '';
  }

  function isConditionOption(root) {
    var label = getOptionLabel(root);
    if (!label) return false;

    var key = normalise(getOptionName(label));

    if (CONDITION_KEYS[key]) return true;

    if (key === 'title') {
      return !!KNOWN_GRADES[normalise(getSelectedValue(root, label))];
    }

    return false;
  }

  function renameConditionLabel(label) {
    if (!label || label.dataset.pctConditionLabelNormalised) return;

    for (var i = 0; i < label.childNodes.length; i += 1) {
      var node = label.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && (node.nodeValue || '').trim()) {
        node.nodeValue = 'Condition: ';
        label.dataset.pctConditionLabelNormalised = '1';
        return;
      }
    }
  }

  function optionValueCount(root) {
    var radios = root.querySelectorAll('input[type="radio"]');
    if (radios.length) return radios.length;

    var select = root.querySelector('select');
    if (select) return select.options.length;

    var roleRadios = root.querySelectorAll('[role="radio"]');
    if (roleRadios.length) return roleRadios.length;

    return 0;
  }

  function applyUniversalCondition() {
    var target = null;

    document.querySelectorAll('.product-form__option').forEach(function (root) {
      if (!isConditionOption(root)) return;

      root.classList.add('pct-condition-option');
      root.style.removeProperty('display');

      if (optionValueCount(root) === 1) {
        root.classList.add('pct-condition-option--single');
      }

      renameConditionLabel(getOptionLabel(root));

      if (!target) target = root;
    });

    if (!target) return;

    var legacy = document.querySelector('.pct-cosmetic-merged');
    var guide = document.querySelector('.pct-guide-wrap');

    if (legacy && guide && legacy.contains(guide)) {
      target.appendChild(guide);
    }

    if (legacy) legacy.remove();

    guide = document.querySelector('.pct-guide-wrap');

    if (guide) {
      var guideText = guide.querySelector('[data-pct-guide-open] span:last-child');
      if (guideText) guideText.textContent = 'View Guide';

      target.classList.add('pct-condition-unified');

      if (!target.contains(guide)) {
        target.appendChild(guide);
      }

      guide.dataset.pctMerged = '1';
    }
  }

  function startUniversalCondition() {
    applyUniversalCondition();

    var productArea = document.querySelector('.product-form') || document.body;
    var scheduled = false;

    new MutationObserver(function () {
      if (scheduled) return;

      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyUniversalCondition();
      });
    }).observe(productArea, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startUniversalCondition, { once: true });
  } else {
    startUniversalCondition();
  }
})();

/* PCT Condition Guide Visibility Guard 121026 */
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  var VALID_GUIDE_GRADES = {
    'excellenta+': true,
    excellent: true,
    verygood: true,
    good: true
  };

  var CONDITION_KEYS = {
    condition: true,
    productcondition: true,
    cosmeticcondition: true,
    cosmeticcondtion: true,
    cosmetic: true
  };

  function normalise(text) {
    return (text || '').toLowerCase().trim().replace(/[\s_-]+/g, '');
  }

  function optionName(root) {
    var label = root.querySelector('.product-form__option-name');
    if (!label) return '';
    var text = label.textContent || '';
    return normalise(text.split(':')[0]);
  }

  function selectedValue(root) {
    var selected = root.querySelector('.product-form__selected-value');
    if (selected && selected.textContent.trim()) return selected.textContent.trim();

    var checked = root.querySelector('input:checked');
    if (checked && checked.value) return checked.value.trim();

    var select = root.querySelector('select');
    if (select && select.options && select.selectedIndex >= 0) {
      return (select.options[select.selectedIndex].textContent || select.value || '').trim();
    }

    var label = root.querySelector('.product-form__option-name');
    var text = label ? (label.textContent || '') : '';
    var colon = text.indexOf(':');
    return colon >= 0 ? text.slice(colon + 1).trim() : '';
  }

  function hasValidConditionGrade() {
    var roots = document.querySelectorAll('.product-form__option');

    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      var key = optionName(root);
      var grade = normalise(selectedValue(root));

      if ((CONDITION_KEYS[key] || key === 'title') && VALID_GUIDE_GRADES[grade]) {
        return true;
      }
    }

    return false;
  }

  function applyGuideVisibility() {
    var guide = document.querySelector('.pct-guide-wrap');
    if (!guide) return;

    if (hasValidConditionGrade()) {
      if (guide.dataset.pctGuideHiddenNoGrade === '1') {
        guide.style.removeProperty('display');
        delete guide.dataset.pctGuideHiddenNoGrade;
      }
    } else {
      if (guide.dataset.pctGuideHiddenNoGrade !== '1') {
        guide.style.setProperty('display', 'none', 'important');
        guide.dataset.pctGuideHiddenNoGrade = '1';
      }
    }
  }

  function startGuideVisibility() {
    applyGuideVisibility();

    var productArea = document.querySelector('.product-form') || document.body;
    var scheduled = false;

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyGuideVisibility();
      });
    }

    productArea.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(productArea, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGuideVisibility, { once: true });
  } else {
    startGuideVisibility();
  }
})();